module.exports = __webpack_public_path__ + "img/arrow-left.963ec438.svg";